// extracted by mini-css-extract-plugin
export default {"PrescriptionPhoto":"PrescriptionPhoto_PrescriptionPhoto__z8CKb","linkWrap":"PrescriptionPhoto_linkWrap__nDmcZ","image":"PrescriptionPhoto_image__7rfdy"};